module.exports = __webpack_public_path__ + "img/favicon.122708f2.png";